import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

/**
 * @function scrollToHash
 * @description ページ内リンク
 */
const scrollToHash = (hashtag: string, event: Event | null): void => {
  if (!hashtag.startsWith('#')) {
    console.warn('hashtag は # から始まっていません:', hashtag);
    return;
  }
  const element = hashtag !== '' ? document.querySelector(hashtag) : '';
  const scroll_duration = 0.3;
  const offset_element = document.querySelector('.l-header');
  const offset = offset_element ? offset_element.clientHeight : 0;
  // const offset = 0;
  if (!element) {
    console.warn(`${hashtag} の要素はありません`);
    if (event) event.preventDefault();
    return;
  }
  if (event) event.preventDefault();
  gsap.to(window, {
    duration: scroll_duration,
    scrollTo: { y: element, offsetY: offset },
  });
};

/**
 * @function isTouchDevice
 * @description タッチデバイスかどうかを判定する
 */
const isTouchDevice = (): boolean => {
  const uaDataMobile = (navigator as any).userAgentData?.mobile;
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || window.matchMedia('(pointer: coarse)').matches || uaDataMobile === true;
};

/**
 * @function isMobileOrTablet
 * @description デバイスがモバイル/タブレットの場合にtrueを返す
 */
const isMobileOrTablet = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

/**
 * @function getDeviceType
 * @description "smartphone", "tablet", "pc" のいずれかを返す
 */
const getDeviceType = (): 'tablet' | 'smartphone' | 'pc' => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isTablet = /(ipad|tablet|nexus 7|playbook|silk)|(android(?!.*mobi))/i.test(userAgent);
  const isMobile = /iphone|ipod|android.*mobile|windows phone|blackberry.*mobile/i.test(userAgent);

  if (isTablet) {
    return 'tablet';
  }
  if (isMobile) {
    return 'smartphone';
  }
  return 'pc';
};

/**
 * @function toggleBodyClass
 * @description bodyのclassのトグル
 * @returns bodyのclassがadd/removeされたら、true,false
 */
const toggleBodyClass = (className: string): boolean => {
  if (document.body.classList.contains(className)) {
    document.body.classList.remove(className);
    return false;
  } else {
    document.body.classList.add(className);
    return true;
  }
};

/**
 * @function isHTMLElement
 * @description 返り値は boolean だけど、true の場合は el が HTMLElement になる
 */

const isHTMLElement = (el: unknown): el is HTMLElement => {
  return el instanceof HTMLElement;
};

/**
 * @function isInstanceOf
 * @description 返り値は boolean だけど、true の場合は el が 型 になる。isInstanceOf<HTMLElement>(el, HTMLElement)
 */
const isInstanceOf = <T>(el: unknown, constructor: new (...args: any[]) => T): el is T => el instanceof constructor;

export { scrollToHash, isTouchDevice, isMobileOrTablet, getDeviceType, toggleBodyClass, isHTMLElement, isInstanceOf };
